module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-返回-暗.80f62.png";